import { useQueryClient } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import { FinanceCategoryResponse } from "@/types";
import { httpRequest } from "@/lib/axios";

export type FinanceCategoryRequestDTO = {
  name: string;
};

async function createFinanceCategory(
  request: FinanceCategoryRequestDTO
): Promise<FinanceCategoryResponse> {
  const response = await httpRequest.post<FinanceCategoryResponse>(
    "/finance-categorie-entries",
    request
  );
  return response.data;
}

export function useCreateFinanceCategoryMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createFinanceCategory,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["finance-categorie-entries"],
      });
    },
  });
}
